module.exports = __webpack_public_path__ + "assets/img/box1-1.0c750b82.svg";